import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_ALL_PROVIDER_LIST_DETAILS =
  'UPDATE_ALL_PROVIDER_LIST_DETAILS';
export const UPDATE_ALL_PROVIDER_LIST_DETAILS_SUCCESS =
  'UPDATE_ALL_PROVIDER_LIST_DETAILS_SUCCESS';
export const UPDATE_ALL_PROVIDER_LIST_DETAILS_FAILURE =
  'UPDATE_ALL_PROVIDER_LIST_DETAILS_FAILURE';

// Action Creators
export const fetchUpdateAllProviderListDetails = () => ({
  type: UPDATE_ALL_PROVIDER_LIST_DETAILS,
});

export const fetchUpdateAllProviderListDetailsSuccess = (data) => ({
  type: UPDATE_ALL_PROVIDER_LIST_DETAILS_SUCCESS,
  payload: data,
});

export const fetchUpdateAllProviderListDetailsFailure = (error) => ({
  type: UPDATE_ALL_PROVIDER_LIST_DETAILS_FAILURE,
  payload: error,
});

// Thunk Function
export const updateAllProviderListDetailsCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateAllProviderListDetails(data, external));
    try {
      const response = await putMethodWithToken(
        url.upateAllProviderListDetailsSuperAdmin + external?.id + '/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateAllProviderListDetailsSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateAllProviderListDetailsFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateAllProviderListDetailsFailure(error.message));
    }
  };
};
